const WaitingRoomExtraData = "waiting_room";

export const PedagogyConstants = {
    WaitingRoomExtraData,
};